import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { LoadingSpinner } from '@/components/Generic'
import { DisplayDocumentCore } from '@/components/DisplayDocumentCore/DisplayDocumentCore'
import { API_URL, EASYSIGN_SERVICE_PATH, JOINTSIGNING_SERVICE_PATH } from '@/constants/apiUrl'
import { axiosInstance } from '@/methods/axiosConfig'
import { devLog } from '@/methods/devLog'
import type { EditableField } from '@/components/SignDocumentCommon/types'

interface GetJointSigningContextResponse {
  signatoriesStatus: string
  isCounterSigningRequired: boolean
  isCounterSigningReady: boolean
  waitingOnSignatories: Array<{
    id: string
    status: string
    firstName?: string
    lastName?: string
    nextSignatoryUrl?: string
  }>
  enableNextSignatory?: boolean
  editableFields?: EditableField[]
}

export const SignDocumentWithStampsPage = observer(() => {
  const store = useContext(StoreContext)
  const { easySignDocumentPage: trans, easySignSignaturePage: transSignature } =
    store.TranslationsState.translationsNew

  const [isLoading, setIsLoading] = useState(true)
  const [editableFields, setEditableFields] = useState<EditableField[]>([])

  const getContext = async () => {
    try {
      const { data } = await axiosInstance.get<GetJointSigningContextResponse>(
        `${API_URL}/${JOINTSIGNING_SERVICE_PATH}/get-context`,
        {
          withCredentials: true,
        }
      )

      if (data?.editableFields?.length) {
        setEditableFields(data.editableFields)
      }
    } catch (error) {
      devLog('Error fetching joint signing context:', error)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    void getContext()
  }, [])

  if (isLoading) {
    return (
      <div className="page-container mobile-m-0">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <DisplayDocumentCore
      transOverwrite={{ ...trans, transSignature: transSignature }}
      service={EASYSIGN_SERVICE_PATH}
      editableFields={editableFields}
    />
  )
})
